import gql from 'graphql-tag'

export const GET_ADDRESS_CATEGORIES = gql`
  query AddressCategories($filter: GetAddressCategoryFilter) {
    addressCategories(filter: $filter) {
      isSuccessful
      message
      addressCategories {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`

export const CREATE_ADDRESS_CATEGORIES = gql`
  mutation CreateAddressCategory($input: CreateLookupInputSimple!) {
    createAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }
`

export const DELETE_ADDRESS_CATEGORIES = gql`
  mutation DeleteAddressCategory($input: DeleteLookupInputSimple!) {
    deleteAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }
`

export const UPDATE_ADDRESS_CATEGORIES = gql`
  mutation UpdateAddressCategory($input: UpdateLookupInputSimple!) {
    updateAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }
`
